import axios from "axios";

// Determine API URL based on environment
const getApiUrl = () => {
  if (window.location.port === '3000') {
    // Development: Try proxy first, fallback to direct
    return "/auth/login";
  } else {
    // Production: Direct API call
    return "/auth/login";
  }
};

const API_URL = getApiUrl();

export async function login(username, password) {
  try {
    console.log('Attempting login to:', API_URL);
    console.log('Login data:', { username }); // Don't log password
    
    const response = await axios.post(API_URL, 
      { username, password },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    if (response.data && response.data.access_token) {
      localStorage.setItem("token", response.data.access_token);
      console.log('Login successful');
      return true;
    }
    console.log('Login failed: no access token in response');
    return false;
  } catch (error) {
    console.error('Login error:', error.response?.data || error.message);
    
    // If proxy fails, try direct connection to backend
    if (window.location.port === '3000') {
      console.log('Proxy failed, trying direct connection...');
      try {
        const directResponse = await axios.post('http://localhost:8000/auth/login', 
          { username, password },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );
        if (directResponse.data && directResponse.data.access_token) {
          localStorage.setItem("token", directResponse.data.access_token);
          console.log('Direct login successful');
          return true;
        }
      } catch (directError) {
        console.error('Direct connection also failed:', directError.response?.data || directError.message);
      }
    }
    
    return false;
  }
}

export function getToken() {
  const token = localStorage.getItem("token");
  console.log('Getting token from localStorage:', token ? 'Token exists' : 'No token');
  return token;
}

export function logout() {
  console.log('Logging out, removing token');
  localStorage.removeItem("token");
}

export function isTokenExpired() {
  const token = getToken();
  if (!token) return true;
  
  try {
    // Decode JWT token to check expiration
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    console.log('Token expiration check:', {
      expires: payload.exp,
      current: currentTime,
      isExpired: payload.exp < currentTime
    });
    return payload.exp < currentTime;
  } catch (error) {
    console.error('Error checking token expiration:', error);
    return true;
  }
}
